module.exports = __webpack_public_path__ + "img/logo.b03289c7.png";